import React from 'react';
import { AppBar, Box, Button, Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArticleIcon from '@mui/icons-material/Article';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import Stepper from '@mui/material/Stepper';
import StepButton from '@mui/material/StepButton';
import Step from '@mui/material/Step';
import { useNavigate, useParams } from 'react-router-dom';
import { decryptData, handleHttpError, obterCorPorStatus } from '../utils';
import { useSnackbar } from '../hooks/useSnackbar';
import { useQuery } from '../hooks/useQuery';
import DetalheNotaFiscalStep1 from '../components/DetalheNotaFiscalStep1';
import DetalheNotaFiscalStep2 from '../components/DetalheNotaFiscalStep2';
import DetalheNotaFiscalStep3 from '../components/DetalheNotaFiscalStep3';
import DetalheNotaFiscalStep4 from '../components/DetalheNotaFiscalStep4';

const steps = [
  {
    titulo: 'Nota Fiscal',
    render: () => <DetalheNotaFiscalStep1 />,
  },
  {
    titulo: 'Ordens de Serviços',
    render: () => <DetalheNotaFiscalStep2 />,
  },
  {
    titulo: 'PDF da Nota Fiscal',
    render: () => <DetalheNotaFiscalStep3 />,
  },
  {
    titulo: 'Demais arquivos',
    render: () => <DetalheNotaFiscalStep4 />,
  },
];

export default function NotaFiscalVisualizar() {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  let { nota_fiscal_id } = useParams();

  const [isLoading, setIsLoading] = React.useState(true);
  const [nota, setNota] = React.useState(null);
  const [activeStep, setActiveStep] = React.useState(0);

  const {
    obterNotaFiscalPorId,
    obterOrdemsDeServicoPeloIdDaNota,
    listarArquivosNotaFiscal,
  } = useQuery();

  React.useEffect(() => {
    const id = decryptData(nota_fiscal_id);

    if (!id) {
      navigate(-1);
      return;
    }
    fetchNotaFiscal(id);
  }, []);

  const fetchNotaFiscal = async (id) => {
    setIsLoading(false);
    return;
    try {
      let nota = obterNotaFiscalPorId(id);
      let ordens = obterOrdemsDeServicoPeloIdDaNota(id);
      let notaFile = listarArquivosNotaFiscal(id, 'nota-fiscal');
      let files = listarArquivosNotaFiscal(id, 'adicional');

      [nota, ordens, notaFile, files] = await Promise.all([
        nota,
        ordens,
        notaFile,
        files,
      ]);

      setNota(nota.data.data);
      setIsLoading(false);
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    }
  };

  return (
    <Box mt={8} sx={{ width: '100%' }}>
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container spacing={0}>
          <Grid
            item
            alignItems={'center'}
            display={'flex'}
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <IconButton onClick={() => navigate(-1)}>
                <ArrowBackIcon
                  sx={{
                    fontSize: 30,
                    display: { xs: 'none', md: 'flex' },
                    color: '#fff',
                  }}
                />
              </IconButton>

              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                  mr: 1,
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>
                Visualizar nota fiscal
              </span>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <Box padding={5}>
        <Grid container spacing={10}>
          <Grid item sm={12}>
            {isLoading && <CircularProgress />}
            <Stepper activeStep={activeStep} nonLinear>
              {steps.map((step, index) => {
                return (
                  <Step key={step.title}>
                    <StepButton
                      color="inherit"
                      onClick={() => setActiveStep(index)}
                    >
                      {step.titulo}
                    </StepButton>
                  </Step>
                );
              })}
            </Stepper>

            {steps[activeStep].render()}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
